import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { updateUser } from "../api";

export const useUpdateUser = () => {
  const router = useNavigate();
  const queryClient = useQueryClient();
  const { mutate, isPending } = useMutation({
    mutationFn: updateUser,
    onSuccess() {
      queryClient.refetchQueries({ queryKey: ["USER"] });
      queryClient.refetchQueries({ queryKey: ["USER_ID"] });
      router(-1);
    },
  });

  return { update: mutate, isPending };
};
